import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { fetchTeam } from "#modules/users/infra/fetchTeam.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const teamQuery = () => ({
  queryKey: queryKeys.team.mine,
  queryFn: () => fetchTeam(),
  staleTime: STALE_TIME_L,
});
